export default __webpack_public_path__ + "static/faustinoMota-1eef622061c605b28b71d2e30f7f8598.jpg";